import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { Provider } from "@angular/core";
import { AuthInterceptor } from "./auth.interceptor";
import { BlobErrorHttpInterceptor } from "./blob-error.interceptor";
import { ErrorInterceptor } from "./error.interceptor";
import { HeadersInterceptor } from "./headers.interceptor";
import { ShadowInterceptor } from "./shadow.interceptor";

export const httpInterceptorProviders: Provider[] = [
  { provide: HTTP_INTERCEPTORS, useExisting: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useExisting: ShadowInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useExisting: ErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useExisting: BlobErrorHttpInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useExisting: HeadersInterceptor, multi: true },
];
